import { ThemedIllustration } from "@src/common/ThemedIllustration";
import { LAYOUT_CONSTANTS } from "@src/constants";
import { MEDIA_QUERIES } from "@src/constants/media-queries";
import { useMediaQuery } from "@uhg-abyss/web/hooks/useMediaQuery";
import { styled } from "@uhg-abyss/web/tools/styled";
import type { ValidIllustrationBrandName } from "@uhg-abyss/web/ui/IllustrationBrand";
import { type FC, Fragment } from "react";

const DEFAULT_BACKGROUND_HEIGHT = 356;

const BackgroundDiv = styled("div", {
  width: "100vw",
  maxWidth: LAYOUT_CONSTANTS.maxPageWidth,
  backgroundColor: "$app.color.top.background",
  position: "absolute",
  top: 0,
  zIndex: 2,
  borderBottom: "1px solid $app.color.default.border",
});

const InteractiveCounselingStyle = {
  width: "304px",
  height: "188px",
  marginTop: "16px",
};

interface IllustrationBGProps {
  iconName?: ValidIllustrationBrandName | "interactive_counseling" | "" | null | string;
  ariaLabel?: string;
  // Grows the background when page content is taller than the default; never shrinks below it.
  minHeight?: number;
}

export const IllustrationBG: FC<IllustrationBGProps> = ({ iconName, ariaLabel, minHeight }) => {
  const isTablet = useMediaQuery(MEDIA_QUERIES.tabletMax);

  return (
    <Fragment>
      <BackgroundDiv
        className="background-div"
        css={{ height: `${Math.max(minHeight ?? 0, DEFAULT_BACKGROUND_HEIGHT)}px` }}
      />
      {!isTablet && iconName && (
        <div
          className="illustration-div"
          style={{
            position: "absolute",
            maxWidth: LAYOUT_CONSTANTS.maxContentWidth,
            zIndex: 2,
            width: "100vw",
            justifySelf: "center",
          }}
        >
          <ThemedIllustration
            themeIllustrationName={iconName}
            altText={ariaLabel}
            {...(iconName === "interactive_counseling"
              ? {
                  localSrc: "/illustrations/interactive_counseling.svg",
                  defaultLocalImageStyle: InteractiveCounselingStyle,
                }
              : {
                  brandProps: {
                    illustration: iconName as ValidIllustrationBrandName,
                    size: "304px",
                    css: {
                      "abyss-illustration-brand-root": {
                        transform:
                          iconName === "digital_insurance_card" ? "rotateY(180deg)" : "none", // Flip horizontally if iconName matches
                      },
                    },
                  },
                })}
          />
        </div>
      )}
    </Fragment>
  );
};
